import { Ban, LogOut } from 'lucide-react';
import { useAuth } from '@/lib/SupabaseAuthContext';

export default function BannedScreen() {
  const { logout } = useAuth();
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background px-6 text-center">
      <div className="flex h-16 sm:h-20 w-16 sm:w-20 items-center justify-center rounded-3xl bg-red-500/10">
        <Ban className="h-10 w-10 text-red-500/60" />
      </div>
      <h1 className="mt-6 text-2xl font-bold tracking-tight text-red-500">Account Banned</h1>
      <p className="mt-3 max-w-md text-sm text-muted-foreground">
        Your account has been banned by an administrator. If you believe this is a mistake, please contact support.
      </p>
      <button
        onClick={() => logout()}
        className="mt-8 inline-flex items-center gap-2 rounded-xl bg-foreground/10 px-5 py-2.5 text-sm font-medium text-foreground/70 ring-1 ring-inset ring-border transition hover:bg-foreground/20"
      >
        <LogOut className="h-4 w-4" /> Log out
      </button>
    </div>
  );
}